/**
 * Created by Aleksandr on 27.04.2023
 */

const PawBoxIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.pawbox_icon_json,
        titleIcon: bundles.sidebar.frames.pawbox_titleIcon,
        control: "PawBoxIcon",
        targets: ["pawsPoints"]
    });
};

PawBoxIcon.prototype = Object.create(SideBarIcon.prototype);
PawBoxIcon.prototype.constructor = PawBoxIcon;

PawBoxIcon.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        focus: "PawBoxIconClicked",
        action: function (f) {
            new GuideWindow({
                name: "PawBoxGuideWindow",
                bundle: bundles.pawbox_guide_window
            });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

PawBoxIcon.prototype.resetState = function () {
    this.available = false;
    if (cleverapps.meta.getSelectedLocation().locationConfig.isMain || !Map2dLocation.currentLocation || !Map2dLocation.currentLocation.pawBox) {
        return;
    }

    if (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation && Map2dLocation.currentLocation.pawBox && PawBox.IsIconActive()) {
        this.available = true;
    }

    this.setTitle(`${Map2dLocation.currentLocation.pawBox.getPoints()}/${PawBox.GOAL}`);
};
